import { render } from "./CourseView.vue?vue&type=template&id=774f0158"
import script from "./CourseView.vue?vue&type=script&lang=js"
export * from "./CourseView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__